<!-- 进出水分析 -->
<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <AreaTreeCard
            ref="areaTreeCard"
            :area-loading="areaLoading"
            :area-tree="areaTree"
            :curr-selected="currSelected"
            @node-selected="handleNodeSelected"
            @node-unselected="handleNodeUnselected"
            @unselect="resetAareaData"
            @collapse-all="collapseAll"
            @area-add="handleAreaAdd"
            @add-child="handleAdd"
            @delete="handleDelete"
            @toggle-visibility="handleTreeToggle"
          />
        </a-card>
      </a-row>
    </a-col>
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-left: 30px" class="new-col">
      <a-icon
        :type="collapsed ? 'caret-right' : 'caret-left'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
      <a-card :bordered="false">
        <!-- 区域信息标签页 -->
        <a-collapse v-model="areaInfoActiveKey" :bordered="false" style="margin-bottom: 16px">
          <a-collapse-panel key="areaInfo" :header="$t('区域&流量计信息')">
            <a-spin :spinning="areaInfoLoading">
              <template v-if="currSelected.id">
                <a-descriptions size="small" :column="3" bordered>
                  <a-descriptions-item :label="$t('区域名称')">{{ areaInfo.name }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('片区编码')">{{ areaInfo.code }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('分区级别')">{{ areaInfo.areaLevel }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('区域面积(m³)')">{{ areaInfo.areaExtent }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('用户数')">{{ areaInfo.customerCount }}</a-descriptions-item>
                </a-descriptions>
                <div style="margin-top: 12px; margin-bottom: 8px; font-weight: bold">{{ $t('已绑定流量计') }}</div>
                <a-table
                  size="small"
                  rowKey="id"
                  bordered
                  :scroll="{ x: true }"
                  :columns="meterColumns"
                  :dataSource="meterList"
                  :pagination="false"
                  :loading="meterLoading"
                />
              </template>
              <a-empty v-else :description="$t('请先在左侧选择区域')" />
            </a-spin>
          </a-collapse-panel>
        </a-collapse>
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="8" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('日期')">
                  <a-range-picker
                    v-model="date"
                    format="YYYY-MM-DD"
                    value-format="YYYY-MM-DD"
                    :disabled-date="disabledDate"
                    :placeholder="[$t('开始日期'), $t('结束日期')]"
                    style="width: 100%"
                    @calendarChange="onCalendarChange"
                    @change="onRangeChange"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
            <template slot="leakageFinalRate" slot-scope="text">
              <span :style="finalRateStyle(text)" style="font-weight: bold">{{ text == null || text === '' ? '-' : text }}</span>
            </template>
          </a-table>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>
        
<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import AreaTreeCard from '../AreaTreeCard.vue'
import moment from 'moment'
export default {
  name: 'InletAndOutletWaterAnalysis',
  mixins: [JeecgListMixin, AreaChoosetMixin, mixinDevice],
  components: {
    JInput,
    AreaTreeCard,
  },
  data() {
    return {
      description: '入流出流分析',
      collapsed: false,
      // 区域信息标签页
      areaInfoActiveKey: ['areaInfo'],
      areaInfo: {},
      areaInfoLoading: false,
      meterList: [],
      meterLoading: false,
      url: {
        list: '/jeecg-charge/wq/emfFlowUpDataDay/list',
        queryAreaById: '/jeecg-gis/area/queryById',
        queryNodeList: '/jeecg-gis/topology/node/list',
      },
      date: [],
      // range-picker 首个选中日期(用于限制最大范围)
      selectDate: null,
      queryParam: {},
    }
  },
  created() {
    // 默认查询最近7天
    const end = moment()
    const begin = moment().subtract(6, 'days')
    this.date = [begin.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')]
  },
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    meterColumns() {
      return [
        { title: this.$t('名称'), align: 'center', dataIndex: 'name' },
        { title: this.$t('节点编码'), align: 'center', dataIndex: 'code' },
        { title: this.$t('物联设备id'), align: 'center', dataIndex: 'deviceIdNew' },
        { title: this.$t('转换系数'), align: 'center', dataIndex: 'conversionCoefficientNew' },
      ]
    },
    columns() {
      return [
        {
          title: this.$t('序号'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('日期'),
          align: 'center',
          dataIndex: 'recordDate',
        },
        {
          title: this.$t('区域供水量m³'),
          align: 'center',
          dataIndex: 'supplyQuantity',
        },
        {
          title: this.$t('区域用水量（m³）'),
          align: 'center',
          dataIndex: 'usageQuantity',
        },
        {
          title: this.$t('居民用水量m³'),
          align: 'center',
          dataIndex: 'userUseQuantity',
        },
        {
          title: this.$t('基础漏损率%'),
          align: 'center',
          dataIndex: 'leakageBaseRate',
        },
        {
          title: this.$t('最终漏损率%'),
          align: 'center',
          dataIndex: 'leakageFinalRate',
          scopedSlots: { customRender: 'leakageFinalRate' },
        },
        {
          title: this.$t('抄表修正率%'),
          width: 100,
          ellipsis: true,
          align: 'center',
          dataIndex: 'r1',
        },
        {
          title: this.$t('水管修正值%'),
          align: 'center',
          dataIndex: 'r2',
        },
        {
          title: this.$t('管压修正率%'),
          align: 'center',
          dataIndex: 'r3',
        },
        {
          title: this.$t('冻土修正率%'),
          align: 'center',
          dataIndex: 'r4',
        },
      ]
    },
  },
  methods: {
    // 查询供水量日数据列表
    async loadData(arg) {
      if (!this.currSelected || !this.currSelected.id) {
        this.dataSource = []
        this.ipagination.total = 0
        return
      }
      if (arg === 1) {
        this.ipagination.current = 1
      }
      try {
        this.loading = true
        let params = {
          gisAreaId: this.currSelected.id,
          pageNo: this.ipagination.current,
          pageSize: this.ipagination.pageSize,
        }
        // recordDate 范围查询,Jeecg QueryGenerator 约定字段名加 _begin/_end 后缀
        if (this.date && this.date.length === 2) {
          params.recordDate_begin = this.date[0]
          params.recordDate_end = this.date[1]
        }
        const res = await getAction(this.url.list, params)
        if (res.code == 200 || res.success) {
          const result = res.result || {}
          this.dataSource = result.records || []
          this.ipagination.total = result.total || 0
        } else {
          this.dataSource = []
          this.ipagination.total = 0
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      } catch (err) {
        console.log('查询供水量日数据失败:', err)
        this.dataSource = []
        this.ipagination.total = 0
      } finally {
        this.loading = false
      }
    },
    // 选择左侧区域节点时,查询区域详情及绑定流量计
    async handleNodeSelected(record) {
      this.currSelected = record
      const areaId = record.id
      if (!areaId) {
        this.resetAreaInfo()
        return
      }
      // 查询区域详情
      this.areaInfoLoading = true
      try {
        const res = await getAction(this.url.queryAreaById, { id: areaId })
        this.areaInfo = res.code == 200 ? res.result : {}
      } catch (err) {
        console.log('查询区域详情失败:', err)
        this.areaInfo = {}
      } finally {
        this.areaInfoLoading = false
      }
      // 查询绑定的流量计 type=fm
      this.meterLoading = true
      try {
        const res = await getAction(this.url.queryNodeList, {
          areaId: areaId,
          // type 为枚举 NodePipelineTypeEnum，Spring 按枚举常量名 name() 绑定
          type: 'NODE_PIPELINE_TYPE_FM',
          pageNo: 1,
          pageSize: 1000,
        })
        const result = res.result || {}
        this.meterList = result.records || result || []
      } catch (err) {
        console.log('查询绑定流量计失败:', err)
        this.meterList = []
      } finally {
        this.meterLoading = false
      }
      // 触发右侧列表查询
      this.loadData(1)
    },
    // 取消选择节点
    handleNodeUnselected() {
      this.resetAreaInfo()
    },
    resetAreaInfo() {
      this.areaInfo = {}
      this.meterList = []
      this.dataSource = []
      this.ipagination.total = 0
    },
    // 以下为区域树编辑相关事件占位，本页面为只读分析页，暂不处理
    handleAreaAdd() {},
    handleAdd() {},
    handleDelete() {},
    handleTreeToggle() {},
    // 最终漏损率着色：<5 蓝，[5,10) 黄，>=10 红
    finalRateStyle(val) {
      const num = Number(val)
      let color = ''
      if (!isNaN(num)) {
        if (num < 5) color = '#1890ff'
        else if (num < 10) color = '#faad14'
        else color = '#f5222d'
      }
      return color ? `color: ${color}` : ''
    },
    // 重置查询条件(含日期)
    searchReset() {
      // 恢复为默认最近7天
      this.date = [moment().subtract(6, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      this.queryParam = {}
      this.loadData(1)
    },
    // 禁选日期：未来日期禁选；选定首个日期后，禁选超出 60 天范围的日期
    disabledDate(current) {
      if (!current) return false
      // 不能晚于今天
      if (current > moment().endOf('day')) return true
      // 最大范围 60 天
      if (this.selectDate) {
        const tooEarly = current < moment(this.selectDate).subtract(59, 'days').startOf('day')
        const tooLate = current > moment(this.selectDate).add(59, 'days').endOf('day')
        return tooEarly || tooLate
      }
      return false
    },
    // 选中第一个日期时记录，用于限制可选范围
    onCalendarChange(dates) {
      this.selectDate = dates && dates[0] ? dates[0] : null
    },
    // 范围确认后的兜底校验(超过60天则提示)
    onRangeChange(dates) {
      this.selectDate = null
      if (dates && dates.length === 2 && dates[0] && dates[1]) {
        const diff = Math.abs(moment(dates[0]).diff(moment(dates[1]), 'days')) + 1
        if (diff > 60) {
          this.$message.warning(this.$t('日期最大范围为60天'))
        }
      }
    },
  },
}
</script>
        <style scoped>
@import '~@assets/less/common.less';
</style>